import { useAppStore } from '@store'

/** Evita recentrado 3D durante sustituciones/dibujos que no deben mover la cámara. */
export async function withCameraFitBlocked<T>(operation: () => Promise<T>): Promise<T> {
  const { beginCameraViewPreservation, endCameraViewPreservation, clearCameraFitToItems } =
    useAppStore.getState()

  beginCameraViewPreservation()
  clearCameraFitToItems()
  const intervalId = setInterval(() => {
    clearCameraFitToItems()
  }, 30)

  try {
    return await operation()
  } finally {
    clearInterval(intervalId)
    endCameraViewPreservation()
    clearCameraFitToItems()
    setTimeout(() => clearCameraFitToItems(), 120)
  }
}
